import React from 'react'
import styled from 'styled-components'
import { Fonts, FontWeights } from '../../../constants'

type ClaimPosition = {
  total: string
  claimed: string
  claimable: string
}

interface Props {
  positions: ClaimPosition[]
}

export function ClaimPositions({ positions }: Props) {
  return (
    <Container>
      <Header>
        <Cell>Vesting</Cell>
        <Cell>Total</Cell>
        <Cell>Claimed</Cell>
        <Cell>Claimable</Cell>
      </Header>
      <Body>
        <Position>
          <Cell>3 Years</Cell>
          <Cell>{positions[0].total}</Cell>
          <Cell>{positions[0].claimed}</Cell>
          <Cell>{positions[0].claimable}</Cell>
        </Position>
        <Position>
          <Cell>6 Months</Cell>
          <Cell>{positions[1].total}</Cell>
          <Cell>{positions[1].claimed}</Cell>
          <Cell>{positions[1].claimable}</Cell>
        </Position>
      </Body>
    </Container>
  )
}

const Container = styled.div``

const Header = styled.div`
  padding-bottom: 10px;
  display: flex;
  justify-content: space-between;
  color: ${({ theme }) => theme.OffWhite};
  font-size: 11px;
  font-family: ${Fonts.Body};
  font-weight: ${FontWeights.Light};
  border-bottom: 1px solid ${({ theme }) => theme.BorderColor};
  text-decoration: none;
`

const Body = styled.div`
  display: flex;
  flex-direction: column;
  place-items: center;
`

const Position = styled.div`
  padding: 5px 0px;
  display: flex;
  width: 100%;
  justify-content: space-between;
  color: ${({ theme }) => theme.OffWhiteHover};
  font-size: 11px;
  font-family: ${Fonts.Body};
  font-weight: ${FontWeights.Regular};
  text-decoration: none;
`

const Cell = styled.div`
  padding: 5px 0px;
  width: 100%;
  text-align: left;
`
